// ====== plugin import ======= //
// ========== plugin import ========= //
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

// ====== component import ========= //
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
const FmHowItsWorks = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className="col-md-12 text-center mb-20">
                <SectionHeader_2
                    title= {`How it works?`}
                    subTitle={`For enterprises who want to entrust us with their AI Agent needs, such that they can focus on their priorities!`}
                />
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Quickest way to hit the ramp!
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Describe what the Agents have to perform
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Provide the access to content, CRM, payment gateway
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Sit back while we get it ready for you in a ziffy!
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto py-10'>
                    <img src="/assets/img/quick.jpg" alt="app image" className="radius-20 w-100" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-4 pe-15 m-auto py-10'>
                    <img src="/assets/img/excited.jpg" alt="app image" className="radius-20 w-100" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        No data required, no trial-and-errors on machine training.
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Data boosting by TruVoice Generative AI to machine train the NLU overnight.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Provides high accuracy from Day 1
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No data gathering, no NLU training needed from you.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        100% customizable conversations
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No rigid flows
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No pre-defined templates
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Fully flexible and engaging 2-way conversations
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto py-10'>
                    <img src="/assets/img/motivated.jpg" alt="app image" className="radius-20 w-100" style={{}} />
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-10'>
                <div className='col-md-4 pe-15 m-auto'>
                    <img src="/assets/img/channel-logo.jpg" alt="app image" className="radius-20 p-10 ps-0 w-100" style={{}} />
                </div>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Integrate with any channel
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className="d-flex text-gray-700 fs-3 text-nowrap">
                                <FontAwesomeIcon icon={faCircleCheck} className="me-2 mt-1" />
                                <span>
                                    You get the&nbsp;
                                    <u style={{ margin: '0 4px' }}>
                                    TruChat Widget<sup style={{ fontSize: '0.7em', verticalAlign: 'baseline', position: 'relative', top: '-0.5em' }}>&nbsp;®</sup>
                                    </u>
                                    &nbsp;by default. Simply add it to any web page you like.
                                </span>
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy integrations with WhatsApp, Telegram, Facebook or any other channel via our universal API end points.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy integrations with any Speech-to-text, Text-to-speech, SIP or other channels via universal API end points.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row  border px-10 br-20 mb-20'>
                <div className='col-md-8 pe-15 m-auto'>
                    <h3 className="section-title fs-1 text-grad-3">
                        Performance monitoring and reporting
                    </h3>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                In-built live reporting module.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Chat transcripts and audio recordings are available on the in-built reporting.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You can use our <u style={{ margin: '0 4px', display: 'inline-block' }}> Reporting APIs </u> to integrate with other reports.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4 text-end m-auto py-10'>
                    <img src="/assets/img/cdr-report.jpg" alt="app image" className="radius-20 w-100" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {FmHowItsWorks}